import SwiperComponent from './SwiperComponent'
export default SwiperComponent
